import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { ListDocument } from 'src/app/shared/models/signature.model';
import { SignatureService } from '../signature-service/signature.service';
import { ToastBehaviorService } from './toast-behavior.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentBehaviorService {
  
  private dataSource = new BehaviorSubject<ListDocument>({"dto":[]})

  data = this.dataSource.asObservable();

  constructor(
    private readonly signatureService: SignatureService,
    private readonly toast: ToastBehaviorService
  ) { }

  getListDocuments() {
    this.signatureService.listDocuments().subscribe((res:any) => {
      this.setData(res.body)
    }, error => {
      this.toast.set('', error, 'bg-danger')
    })
  }

  setData(data:ListDocument){
    this.dataSource.next(data);
  }  
}
